<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5Jj0Nl/images/9781452177427.jpg?1695331308800" alt="This image is the cover for the book Little Plane"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Little Plane
      </h1>
      <p class="bookDescription body article font2">
        <b>Little Plane is learning to fly—and reaching for the sky—in this inspiring adventure for toddlers! </b><br/>  <br/> When you’re small and on the go, there’s a lot to watch out for: tall trees, muddy hills, and more! With wings aloft, Little Plane keeps flying, weathering the bumps along the way with his initiative, confidence, and positive attitude. This colorful follow-up to <i>Little Boat</i> and <i>Little Truck</i> by beloved, award-winning author-illustrator Taro Gomi is a must for toddlers launching upward to big adventures!<br/>  <br/> “I don’t just recommend this new book but ALL of his books—they’re kid-friendly wonderfulness.” —<i>Imagination Soup</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Taro Gomi
      </h2>
      
      <p class="authorDescription body article">Taro Gomi is an internationally renowned author and illustrator who has created more than 400 books for readers of all ages, including the award-winning <I>Over the Ocean</I> and <I>Bus Stops</I>, <I>I Know Numbers!</I>, <I>My Friends</I>, <I>Spring Is Here!</I>, and <I>I Really Want to See You, Grandma</I>. He lives in Tokyo, Japan.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5906aef2